import styles from "./InfoMultiGridSchool.module.css";
import Image from "next/image";
import arrowRightBlack from "../../assets/icons/arrow-right-black.svg";
import certificate from "../../assets/icons/certificate-school.svg";
import crown from "../../assets/icons/crown-school.svg";
import teaching from "../../assets/icons/teaching-school.svg";
import { InfoMultiGridSchoolProps } from "./InfoMultiGridSchool.type";
import Button from "../../components/Button";
import { getImageType } from "../../utils/helper";
import { useSelector } from "react-redux";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import HtmlPopup from "../HtmlPopup";

const InfoMultiGridSchool = (props: InfoMultiGridSchoolProps) => {
  const banners = props?.data;
  const router = useRouter();
  const {color, bgColor, ctaPopupData} = props;
  const { slug } = router?.query;

  const [displayPopup, setDisplayPopup] = useState(false);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const { isMobileDevice } = useSelector((state: any) => state.data);
  

  useEffect(() => {
    document.documentElement.style.setProperty('--button-bg-color', color);
  }, [color]);

  useEffect(() => {
    document.documentElement.style.setProperty('--div-bg-color', bgColor);
  }, [bgColor]);

  //  const imgcontainer = banners[0]?.image?.results?.[0]?.fileUrl;
  

  const bannerImg = banners && banners?.length > 0 && banners?.[0];

  const handleClick = (href: string) => {
    router.push(href);
  };

  const openPopUp = (popup) => {
    if(ctaPopupData?.[popup]){
      setTitle(ctaPopupData?.[popup]?.ctapopupTitle);
      setContent(ctaPopupData?.[popup]?.ctapopup?.content?.[0]?.content?.[0]?.text);
      setDisplayPopup(true);
    }
  }

  return (
    <>
    { banners && (
    <div className="container mt-lg-1 mt-5" data-testid="infomg-container-id">
      <div className="row">
        <div className="col-12 col-md-6 mb-md-0 mb-3">
          <div className={` ${styles.card}`}>
            <Image
              src={getImageType(isMobileDevice, bannerImg)}
              // src={bannerImg?.image?.results[0]?.fileUrl}
              alt="imgcontainer"
              width={300}
              height={584}
              // placeholder="blur"
              // priority={true}
            />
            <div className={` ${styles.overlayText}`}>
              <h1>{banners?.[0]?.title}</h1>
              {/* <a href={banners[0].hyperlink} className={` ${styles.showMore}`}>
                {banners[0].subtitle}
              </a> */}

              <Button
                // onClick={() => handleClick(banners[0]?.hyperlink || "#")}
                className={` ${styles.showMore}`}
              >
                {/* {banners[0].subtitle} */}
                <a
                  href={banners?.[0]?.hyperlink || "#"}
                  target={banners?.[0]?.externallink === true ? "_blank" : ""}
                  className={` ${styles.showMore}`}
                >
                  {banners?.[0]?.subtitle}
                </a>
              </Button>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6">
          <div className={` ${styles.item}`}>
            <div className="col-12">
              <div
                className={`d-flex flex-column ${styles.contentBoxGreenDark}`}
              >
                <div className={` ${styles.content}`}>
                  <Image
                    src={ banners?.[1]?.icon?.results?.[0]?.fileUrl || certificate}
                    alt="certificate"
                    height={56}
                    width={56}
                  />
                  <h3>{banners?.[1]?.title}</h3>
                </div>
                {
                  banners?.[1]?.hyperlink  && (
                <div className={` ${styles.learnMore}`}>
                  <a
                    href={
                      banners?.[1]?.hyperlink !== null
                        ? banners?.[1]?.hyperlink
                        : "#"
                    }
                    className="d-flex justify-content-between align-items-center"
                    target={banners?.[1]?.externallink === true ? "_blank" : ""}
                  >
                    {banners?.[1]?.subtitle}
                    <div className="icon">
                      <Image
                        src={arrowRightBlack}
                        alt="call"
                        height={24}
                        width={24}
                      />
                    </div>
                  </a>
                </div>
                )}
                {
                  slug === "cranleigh-abu-dhabi" && banners?.[1]?.subtitle
                  ? <div 
                      className={` ${styles.learnMore}`} 
                      onClick={()=>openPopUp("skillsCta")}
                    >
                      <div
                      className={` ${styles.learn_more_1} d-flex justify-content-between align-items-center`}
                      >
                        {banners?.[1]?.subtitle}
                        <div className="icon">
                          <Image
                            src={arrowRightBlack}
                            alt="call"
                            height={24}
                            width={24}
                          />
                        </div>
                      </div>
                    </div>
                  : null
                }
              </div>
            </div>
            <div className="col-12">
              <div
                className={`d-flex flex-column ${styles.contentBoxGreenLight}`}
              >
                <div className={` ${styles.content}`}>
                  {" "}
                  <Image
                    src={ banners?.[2]?.icon?.results?.[0]?.fileUrl || crown}
                    alt="crown"
                    height={56}
                    width={56}
                  />
                  <h3 style={{ paddingRight: "15%" }}>{banners?.[2]?.title}</h3>
                </div>
                {
                  banners?.[2]?.hyperlink && (
                <div className={` ${styles.learnMore}`}>
                  <a
                    href={
                      banners?.[2]?.hyperlink !== null
                        ? banners?.[2]?.hyperlink
                        : "#"
                    }
                    className="d-flex justify-content-between align-items-center"
                    target={banners?.[2]?.externallink === true ? "_blank" : ""}
                  >
                    {banners?.[2]?.subtitle}
                    <div className="icon">
                      <Image
                        src={arrowRightBlack}
                        alt="call"
                        height={24}
                        width={24}
                      />
                    </div>
                  </a>
                </div>
                )}
                {
                  slug === "cranleigh-abu-dhabi" && banners?.[2]?.subtitle
                  ? <div 
                      className={` ${styles.learnMore}`} 
                      onClick={()=>openPopUp("clubsCta")}
                    >
                      <div
                      className={` ${styles.learn_more_1} d-flex justify-content-between align-items-center`}
                      >
                        {banners?.[2]?.subtitle}
                        <div className="icon">
                          <Image
                            src={arrowRightBlack}
                            alt="call"
                            height={24}
                            width={24}
                          />
                        </div>
                      </div>
                    </div>
                  : null
                }
              </div>
            </div>
          </div>
          <div className="mt-lg-4 mt-3">
            <div
              className={`col-12 d-flex flex-column justify-content-between ${styles.contentBoxGreen}`}
            >
              <Image
                src={ banners?.[3]?.icon?.results?.[0]?.fileUrl || teaching}
                alt="teaching"
                height={72}
                width={72}
              />
              <h3 className="text_XL_half">{banners?.[3]?.title}</h3>
              {
                banners?.[3]?.hyperlink && (
              <div className={` ${styles.learnMore}`}>
                <a
                  href={
                    banners?.[3]?.hyperlink !== null ? banners?.[3]?.hyperlink : "#"
                  }
                  className="d-flex align-items-center"
                  target={banners?.[3]?.externallink === true ? "_blank" : ""}
                >
                  {banners?.[3]?.subtitle}
                  <div className={` ${styles.icon}`}>
                    <Image
                      src={arrowRightBlack}
                      alt="call"
                      height={24}
                      width={24}
                    />
                  </div>
                </a>
              </div>
               )}
              {
                slug === "cranleigh-abu-dhabi" && banners?.[3]?.subtitle
                ? <div 
                    className={` ${styles.learnMore}`} 
                    onClick={()=>openPopUp("coCurricularCta")}
                  >
                    <div
                      className={` ${styles.learn_more_1} d-flex align-items-center`}
                    >
                      {banners?.[3]?.subtitle}
                      <div className={` ${styles.icon}`}>
                        <Image
                          src={arrowRightBlack}
                          alt="call"
                          height={24}
                          width={24}
                        />
                      </div>
                    </div>
                  </div>
                : null
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    )}
    {
      displayPopup && content && <HtmlPopup 
        showPopup={displayPopup}
        setShowPopup={setDisplayPopup}
        title = {title}
        htmlContent={content}
        isAccordion
      />
    }
  </>
  );
};

export default InfoMultiGridSchool;
